// extracted by mini-css-extract-plugin
export var contactWrap = "contact-module--contactWrap--YLvzo";
export var contactWrapDark = "contact-module--contactWrapDark--j-pDv";